import Form from './CookiesConsentsForm'
import schema from './schema'

export { Form, schema }

export default Form
